import React from 'react';
import TableReport from "../../../common/table/table";
import {tableColumns} from "./tableColumns.js";
import MessageEmptyData from "../../../common/messageEmptyData";
import {isEmpty} from "lodash";

/**
 * Body report component for employee report
 * @param prop
 * @returns {JSX.Element|null}
 * @constructor
 */
const ReportBody = (prop) => {
    const {reportFilters, tableData} = prop;

    if (!reportFilters.isSubmitted) {
        return null;
    }

    if (isEmpty(tableData)) {
        return <MessageEmptyData/>;
    }

    return (
        <div className="container-fluid">
            <TableReport
                columns={tableColumns}
                data={tableData}
                exportOptions={{pdf: false, xlsx: true, csv: true}}
                getExportFileName={() => 'employee_report'}
                withGlobalSearch={true}
                scrollable={true}
            />
        </div>
    );
};

export default ReportBody;
